export enum OverSpentTypeEnum {
    Roaming = "roaming",
    National = "national",
    International = "international"
}

export enum OverSpentKeyTypeEnum {
    CREDIT = "credit",
    ROAMING = "roaming",
    NATIONAL = "national",
    INTERNATIONAL = "international"
}